import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import { connect } from 'react-redux';
import Notification from '../../common/Notification';
import { getCustomAlerts, updateCustomAlert, removeCustomAlert, resendCustomAlert, getDeliveryLog } from '../../../redux/actions/searchAlertsAction';
import { formatUnixDate, getPeriodFromNow } from '../../../utils/dateFormat';
import CustomAlertEdit from './CustomAlertEdit';
import { Loading } from '../../common/Loading';
import DeleteModal from '../../common/Modals/DeleteModal';
import DeliveryLogModal from './DeliveryLogModal';

export class CustomAlerts extends Component {
  static displayName = 'CustomAlerts';

  constructor(props) {
    super(props);
    this.state = {
      alert: {},
      showEditModal: false,
      showRemoveModal: false,
      showLogModal: false,
      logAlert: null,
      onSaveEditModal: () => null,
      onConfirmRemoveModal: () => null,
    };
  }

  componentDidMount() {
    this.props.getCustomAlerts();
  }

  onEditButtonClick = (event, oldAlert, index) => {
    event.preventDefault();

    this.setState({
      showEditModal: true,
      alert: oldAlert,
      onSaveEditModal: (editedAlert) => {
        this.props.updateCustomAlert({ alert: editedAlert, index });
        this.onCloseEditModal();
      },
    });
  };

  onCloseEditModal = () => {
    this.setState({
      showEditModal: false,
      onSaveEditModal: () => null,
    });
  };

  onRemoveButtonClick = (event, alert, index) => {
    event.preventDefault();

    this.setState({
      showRemoveModal: true,
      alert,
      onConfirmRemoveModal: () => {
        this.props.removeCustomAlert({ alert, index });
        this.onCloseRemoveModal();
      },
    });
  };

  onResendButtonClick = (event, alert, index) => {
    event.preventDefault();
    this.props.resendCustomAlert({ alert, index });
  };

  onCloseRemoveModal = () => {
    this.setState({
      showRemoveModal: false,
      onConfirmRemoveModal: () => null,
    });
  };

  onLogButtonClick = (event, alert) => {
    event.preventDefault();
    this.setState({ showLogModal: true, logAlert: alert });
    this.props.getDeliveryLog(alert.id);
  };

  onCloseLogModal = () => {
    this.setState({ showLogModal: false, logAlert: null });
  };


  render() {
    const { alerts, isLoading } = this.props;
    const columns = ['Name', 'Created', 'Last executed', 'Type', 'List', 'Interval', 'Operations'];

    const EditLink = ({ alert, index, children }) => (
      alert.customize_access && !alert.isUpdating
        ? <a href="#" onClick={e => this.onEditButtonClick(e, alert, index)}>{children}</a>
        : <span>{children}</span>
    );

    const hasForwarding = alert =>
      alert.mail_list && alert.mail_list.length > 0
      && alert.notify_interval.toString() !== '-1' && alert.delivery !== 'webhook';

    return (
      <section>
        <Notification />
        <h2>Custom Alerts</h2>
        <table>
          <thead>
            <tr>
              {columns.map((column, index) =>
                <th
                  key={column}
                  colSpan={index === (columns.length - 1) ? 4 : 1}
                >
                  {column}
                </th>)
              }
            </tr>
          </thead>
          <tbody>
            {alerts.length === 0 || isLoading
              ? (
                <tr>
                  <td colSpan="100%">
                    {isLoading
                      ? <Loading show={isLoading} type="bar" />
                      : 'You have created no search alerts yet.'
                    }
                  </td>
                </tr>
              ) : (
                alerts.map((alert, index) => (
                  <tr key={alert.id}>
                    <td>
                      {alert.name}
                    </td>
                    <td>
                      {formatUnixDate(alert.created)}
                    </td>
                    <td>
                      {getPeriodFromNow(alert.last_execute)}
                    </td>
                    <td>
                      {alert.type_label}
                    </td>
                    <td>
                      <EditLink alert={alert} index={index}>
                        <OverlayTrigger
                          trigger={['hover', 'focus']}
                          placement="right"
                          overlay={
                            <Popover id={`popover-list-${alert.id}`}>
                              <strong>To:</strong>
                              {hasForwarding(alert)
                                ?
                                <ul style={{ display: 'inline-grid' }}>
                                  {alert.mail_list.map((email, i) => (
                                    <li
                                      key={i}
                                      style={{ background: 'none' }}
                                    >
                                      {email}
                                    </li>
                                  ))}
                                </ul>
                                :
                                <em>&nbsp;No forwarding set</em>
                              }
                              <hr />
                              {alert.customize_access &&
                                <small>Click the icon to change forwarding settings</small>
                              }
                            </Popover>
                          }
                        >
                          <i
                            className="fa fa-users"
                            style={{
                              color: hasForwarding(alert) ? '#55c231' : 'silver',
                              fontSize: '2em',
                            }}
                          />
                        </OverlayTrigger>
                      </EditLink>
                    </td>
                    <td>
                      <EditLink alert={alert} index={index} >
                        {alert.delivery === 'webhook'
                          ? 'Webhook'
                          : alert.notify_interval_options.find(option => option.value.toString() === alert.notify_interval.toString()).label
                        }
                      </EditLink>
                      {alert.delivery === 'webhook' && (
                        <span style={{ whiteSpace: 'nowrap' }}>
                          {' | '}
                          <a href="#" onClick={e => this.onLogButtonClick(e, alert)}>Log</a>
                          {alert.has_failed_deliveries && (
                            <React.Fragment>
                              {'\u00A0'}
                              <i
                                className="fa fa-exclamation-triangle"
                                style={{ color: '#d9534f' }}
                                title="Recent delivery failures"
                              />
                            </React.Fragment>
                          )}
                        </span>
                      )}
                    </td>
                    {alert.customize_access
                      ? alert.isUpdating
                        ?
                        <td colSpan="4">
                          <Loading show={alert.isUpdating} type="spinner" />
                        </td>
                        :
                        <React.Fragment>
                          <td>
                            <a href="#" onClick={e => this.onEditButtonClick(e, alert, index)}>
                              Edit
                            </a>
                          </td>
                          <td>
                            <a href={alert.url}>Show</a>
                          </td>
                          <td>
                            {alert.isBeingResent
                              ?
                              <Loading show={alert.isBeingResent} type="spinner" />
                              :
                              alert.resend
                                ?
                                <a className="disabled">Resend</a>
                                :
                                <a href="#" onClick={e => this.onResendButtonClick(e, alert, index)}>
                                  Resend
                                </a>
                            }
                          </td>
                          <td>
                            {alert.isBeingRemoved
                              ?
                              <Loading show={alert.isBeingRemoved} type="spinner" />
                              :
                              <a href="#" onClick={e => this.onRemoveButtonClick(e, alert, index)}>
                                Delete
                              </a>
                            }
                          </td>
                        </React.Fragment>
                      :
                      <td colSpan="4">
                        <em>Permission denied</em>
                      </td>
                    }
                  </tr>
                ))
              )
            }
          </tbody>
        </table>
        <div style={{ textAlign: 'right' }}>
          <small>
            <a
              href="#"
              onClick={(e) => { e.preventDefault(); this.props.getCustomAlerts(); }}
            >
              Refresh
            </a>
          </small>
        </div>

        <CustomAlertEdit
          show={this.state.showEditModal}
          onClose={this.onCloseEditModal}
          onSave={this.state.onSaveEditModal}
          alert={this.state.alert}
        />

        <DeleteModal
          show={this.state.showRemoveModal}
          title="Delete Alert"
          onClose={this.onCloseRemoveModal}
          onConfirm={this.state.onConfirmRemoveModal}
        >
          Do you really want to delete <strong>{this.state.alert.name}</strong>?
        </DeleteModal>

        <DeliveryLogModal
          show={this.state.showLogModal}
          alert={this.state.logAlert}
          entries={this.props.deliveryLog}
          isLoading={this.props.deliveryLogLoading}
          error={this.props.deliveryLogError}
          onClose={this.onCloseLogModal}
          onRetry={() => this.props.getDeliveryLog(this.state.logAlert.id)}
        />
      </section>
    );
  }
}

CustomAlerts.propTypes = {
  alerts: PropTypes.array,
  isLoading: PropTypes.bool,
  deliveryLog: PropTypes.array,
  deliveryLogLoading: PropTypes.bool,
  deliveryLogError: PropTypes.any,
  getCustomAlerts: PropTypes.func,
  updateCustomAlert: PropTypes.func,
  removeCustomAlert: PropTypes.func,
  resendCustomAlert: PropTypes.func,
  getDeliveryLog: PropTypes.func,
};

CustomAlerts.defaultProps = {
  alerts: [],
  isLoading: false,
  deliveryLog: [],
  deliveryLogLoading: false,
  deliveryLogError: null,
  getCustomAlerts: () => { },
  updateCustomAlert: () => { },
  removeCustomAlert: () => { },
  resendCustomAlert: () => { },
  getDeliveryLog: () => { },
};

const mapStateToProps = state => ({
  alerts: state.getIn(['customAlerts', 'alerts']).toJS(),
  isLoading: state.getIn(['customAlerts', 'isLoading']),
  deliveryLog: state.getIn(['customAlerts', 'deliveryLog']).toJS(),
  deliveryLogLoading: state.getIn(['customAlerts', 'deliveryLogLoading']),
  deliveryLogError: state.getIn(['customAlerts', 'deliveryLogError']),
});

const mapDispatchToProps = {
  getCustomAlerts,
  updateCustomAlert,
  removeCustomAlert,
  resendCustomAlert,
  getDeliveryLog,
};

export default connect(mapStateToProps, mapDispatchToProps)(CustomAlerts);



// WEBPACK FOOTER //
// ./src/components/searchAlerts/CustomAlerts/CustomAlerts.jsx